document.addEventListener("DOMContentLoaded", function () {
  const logoItems = document.querySelectorAll(".logo-item");
  const noResultsMessage = document.getElementById("no-collections-message");
  const filterButtons = document.querySelectorAll(".filter-button");

  function filterByLetter(letter) {
    let matchFound = false;

    logoItems.forEach((item) => {
      const itemLetter = item.dataset.letter;
      if (letter === "all" || itemLetter === letter) {
        item.style.display = "";
        matchFound = true;
      } else {
        item.style.display = "none";
      }
    });
    if (matchFound) {
      noResultsMessage.classList.add("hidden");
    } else {
      noResultsMessage.classList.remove("hidden");
    }
  }

  filterButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const selectedLetter = this.dataset.letter;
      filterByLetter(selectedLetter);
      filterButtons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");
    });
  });
  filterByLetter("all");
});
